"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var ErrorIcon = function ErrorIcon() {
  return _react.default.createElement("svg", {
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react.default.createElement("title", null, "940AE4E9-AAD5-457F-B672-ACE28539947B"), _react.default.createElement("desc", null, "Created with sketchtool."), _react.default.createElement("g", {
    id: "\uD83D\uDE80-Components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Modal-Component",
    transform: "translate(-1471.000000, -632.000000)",
    fill: "#B32032"
  }, _react.default.createElement("path", {
    d: "M1493,632 C1480.856,632 1471,641.856 1471,654 C1471,666.144 1480.856,676 1493,676 C1505.144,676 1515,666.144 1515,654 C1515,641.856 1505.144,632 1493,632 Z M1495.2,665 L1490.8,665 L1490.8,660.6 L1495.2,660.6 L1495.2,665 Z M1495.2,656.2 L1490.8,656.2 L1490.8,643 L1495.2,643 L1495.2,656.2 Z",
    id: "Error-Icon"
  }))));
};

var _default = ErrorIcon;
exports.default = _default;